import React, { ReactNode } from "react";
import { BoxIcon } from "lucide-react";
type TagTone = "brand" | "accent" | "good" | "bad" | "neutral" | "tint";
interface TagProps {
  children: ReactNode;
  tone?: TagTone;
  icon?: BoxIcon;
  className?: string;
}
const tones: Record<TagTone, string> = {
  brand: "bg-brand text-white",
  accent: "bg-accent text-night",
  good: "bg-good-tint text-ink",
  bad: "bg-bad-tint text-ink",
  neutral: "bg-surface text-ink",
  tint: "bg-brand-tint text-ink"
};
export function Tag({
  children,
  tone = "neutral",
  icon: Icon,
  className = ""
}: TagProps) {
  return <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border-2 border-line px-2 py-0.5 text-[11px] font-semibold leading-4 ${tones[tone]} ${className}`} data-id="element-1222" data-mp="3twsq19mylapt">
      {Icon && <Icon className="h-3 w-3" strokeWidth={2.75} aria-hidden="true" data-id="element-1223" data-mp="196k0o0yxq2t4" />}
      {children}
    </span>;
}